import React from "react";
import styled from "styled-components";
import { partial } from "../../common/utils/partial";

import { ContentBlock } from "../../pages/components";
import { Localize } from "../../../locale/localization";
import Button from "../../../ui/button/Button";
import colors from "../../../utils/colors";

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const StyledFigure = styled.figure`
  width: 25%;
  max-width: 200px;
  margin-right: 2rem;

  img {
    width: 100%;
    height: auto;
  }
`;

const StyledContentWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;

  h6 {
    font-family: FyranSans-SemiBold;
    color: white;
    letter-spacing: 0.125em;
    text-transform: uppercase;
    margin-bottom: 0.625rem;
  }

  h3,
  h4 {
    font-family: FyranSans-SemiBold;
    letter-spacing: 0.013rem;
    font-weight:600;
    color: ${colors.BRAND_PINK};
    margin-bottom: 0.625rem;
  }

  h3 {
    font-size: 1.375rem;
    line-height: 1.5625rem;
  }

  h4 {
    color: ${colors.BRAND_PINK};
  }

  p {
    margin-bottom: 1rem;
  }

  a {
    margin-top: auto;
  }
`;

const MainPrizeItem = props => {
  const { _id, image, price, name, type, onClick } = props;
  return (
    <ContentBlock theme="dark">
      <StyledWrapper>
        {image && (
          <StyledFigure>
            <img src={image} alt="" />
          </StyledFigure>
        )}
        <StyledContentWrapper>
          <h6>{Localize("prize.main.season.header")}</h6>
          <h4>
            {price} {Localize("score")}
          </h4>
          <h3>{name}</h3>
          <p>{type}</p>
          <a onClick={partial(onClick, _id)}>
            <Button theme="light_inverse">{Localize("prize.details")}</Button>
          </a>
        </StyledContentWrapper>
      </StyledWrapper>
    </ContentBlock>
  );
};

export default MainPrizeItem;



// WEBPACK FOOTER //
// ./src/modules/prize/components/MainPrizeItem.js